import { Injectable } from "@angular/core";
import { BaseProvider } from "../BaseProvider";
import { Router, NavigationExtras } from "@angular/router";
import { Http } from "@angular/http";

@Injectable()
export class PartnerCommissionService extends BaseProvider {
    resource = "partners";
    forgotresource = "partners";
    partnerCommissionURL = "partnerCommissionRule";
    // public notify = new Subject<any>();

    constructor(
        private http: Http,
        private router: Router,
    ) {
        super(http);
    }
    getProductWiseCurrency(partnerId, product) {
        return this.makeGetCall(
            "partnerCurrencies/" + "?partnerId=" + partnerId + "&product=" + product,
        );
    }
    getPartnerWiseCurrency(partnerId) {
        return this.makeGetCall("currencyCodes/" + partnerId);
    }
    getIssuerCodeList(partnerId) {
        return this.makeGetCall(
            "ConsumerRateRuleProductIssuer?partnerId=" +
            partnerId +
            "&product=FOREXCARD",
        );
    }
    getBranchesList(partnerId) {
        return this.makeGetCall(
            "consumerRateRuleBranchNames?partnerId=" + partnerId,
        );
    }
    getProductList(partnerId) {
        return this.makeGetCall(
            "ConsumerRateRuleProductIssuer?partnerId=" + partnerId,
        );
    }
    getProductWisePurposeForRates(partnerId, product) {
        return this.makeGetCall(
            "consumerRateRuleProductPurpose?partnerId=" +
            partnerId +
            "&product=" +
            product,
        );
    }
    getSlabList(partnerId, product, issuerCode) {
        return this.makeGetCall(
            "ConsumerRateRuleSlabValue?partnerId=" +
            partnerId +
            "&product=" +
            product +
            "&issuerCode=" +
            issuerCode,
        );
    }
    getSlabListForBranch(partnerId, branchId) {
        return this.makeGetCall(
            "consumerRateRuleBranchSlabValue?partnerId=" +
            partnerId +
            "&branchId=" +
            branchId,
        );
    }
    getCurrenciesList(reqGetCurrencyMaster) {
        var resourceUrl = "currencies";
        return this.makePostCall(resourceUrl, reqGetCurrencyMaster);
    }
    addCurrencies(partnerId, currencyCode, product) {
        return this.makePostCall(
            "addCurrencies?partnerId=" +
            partnerId +
            "&currencyCode=" +
            currencyCode +
            "&product=" +
            product,
            {},
        );
    }
    getPartner() {
        // Fetch all Partner given the token
        return this.makeGetCall("partnersShortSnippet");
    }
    getPartnersForConsumerRateRule() {
        return this.makeGetCall("consumerRateRulePartners");
    }
    getPartnersForConsumerBranchRateRule() {
        return this.makeGetCall("consumerRateRuleBranchPartners");
    }
    getPartnerWithStatus() {
        return this.makeGetCall(this.resource + "?partnerStatus=ACTIVE");
    }
    getPartnerReferrer() {
        // Fetch all Partner given the token
        return this.makeGetCall(
            this.resource + "?excludeWsfx=true" + "&onlyTourReferrers=true",
        );
    }
    getPartnerReferrereTO(partnerId) {
        // Fetch all Partner given the token
        return this.makeGetCall("tourPartners/" + partnerId);
    }
    getPartnerShortSnippet() {
        // Fetch all Partner given the token
        return this.makeGetCall("partnerShortSnippet");
    }
    getAllPartnerCommissionRules() {
        return this.makeGetCall(this.partnerCommissionURL);
    }

    getPartnerCommissionRulesbyPartnerId(partnerId) {
        return this.makeGetCall(
            this.partnerCommissionURL + "?partnerId=" + partnerId,
        );
    }
    getConsumerRateRule(
        partnerId,
        product,
        purpose,
        issuerCode,
        slabMin,
        slabMax,
    ) {
        return this.makeGetCall(
            "consumerRateRule?partnerId=" +
            partnerId +
            (product != -1 ? "&product=" + product : "") +
            (purpose != -1 ? "&purpose=" + purpose : "") +
            (issuerCode != -1 ? "&issuerCode=" + issuerCode : "") +
            (slabMin != -1 ? "&slabMin=" + slabMin : "") +
            (slabMax != -1 ? "&slabMax=" + slabMax : ""),
        );
    }
    getBranchWiseRateRule(partnerId, branchId, slabMin, slabMax) {
        return this.makeGetCall(
            "consumerRateRuleBranchWise?partnerId=" +
            partnerId +
            (branchId != -1 ? "&branchId=" + branchId : "") +
            (slabMin != -1 ? "&slabMin=" + slabMin : "") +
            (slabMax != -1 ? "&slabMax=" + slabMax : ""),
        );
    }
    putConsumerRateRule(partnerId, product, issuerCode, commissionRulesList) {
        return this.makePutCall(
            "consumerRateRuleEdit?partnerId=" +
            partnerId +
            (product != -1 ? "&product=" + product : "") +
            (issuerCode != -1 ? "&issuerCode=" + issuerCode : ""),
            commissionRulesList,
        );
    }
    putCashRateRule(commissionRulesList) {
        return this.makePutCall(
            "consumerRateRuleBranchWiseEdit",
            commissionRulesList,
        );
    }

    updateCommisionRateRules(commissionRulesList: any) {
        // Update a role  given the updated role details
        return this.makePutCall(this.partnerCommissionURL, commissionRulesList);
    }
    deleteCommisionRateRules(
        partnerId: any,
        currency: any,
        product: any,
        purpose: any,
    ) {
        // Update a role  given the updated role details
        return this.makeDeleteCall(
            this.partnerCommissionURL +
            "?partnerId=" +
            partnerId +
            "&currencyCode=" +
            currency +
            "&product=" +
            product +
            "&purpose=" +
            purpose,
        );
    }

    getCommissionCalculator(
        commission,
        currencyAmount,
        currencyCodes,
        partnerId,
        product,
        sellType,
    ) {
        return this.makeGetCall(
            "pricing/rates?commission=" +
            commission +
            "&currencyAmount=" +
            currencyAmount +
            "&currencyCodes=" +
            currencyCodes +
            "&partnerId=" +
            partnerId +
            "&product=" +
            product +
            "&purpose=ANY&sellType=" +
            sellType,
        );
    }

    getPriceRange(product, currencyCode, partnerId, sellType) {
        return this.makeGetCall(
            "pricing/rateRange?product=" +
            product +
            "&currencyCode=" +
            currencyCode +
            "&partnerId=" +
            partnerId +
            "&sellType=" +
            sellType,
        );
    }

    getCommissionByRate(
        rate,
        currencyAmount,
        currencyCodes,
        partnerId,
        product,
        sellType,
    ) {
        return this.makeGetCall(
            "pricing/commissions?rate=" +
            rate +
            "&currencyAmount=" +
            currencyAmount +
            "&currencyCodes=" +
            currencyCodes +
            "&partnerId=" +
            partnerId +
            "&product=" +
            product +
            "&sellType=" +
            sellType,
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/_services/raterule/PartnerCommission.service.ts